// Aceita RG antigo (formato varia por estado, DV pode ser X) e CIN (número = CPF, 11 dígitos).

const MAX_DIGITS = 11;
const MAX_RG_BODY = 8;

// Mantém dígitos e um X final como dígito verificador.
export const sanitizeRg = (value) => {
  const clean = (value || '').toString().toUpperCase().replace(/[^0-9X]/g, '');
  const xIndex = clean.indexOf('X');
  if (xIndex === -1) return clean.slice(0, MAX_DIGITS);

  const body = clean.slice(0, xIndex).slice(0, MAX_RG_BODY);
  if (!body) return '';
  return body + 'X';
};

const formatCin = (clean) =>
  clean.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');

const formatRg = (clean) => {
  let body = clean.slice(0, MAX_RG_BODY);
  let dv = clean.slice(MAX_RG_BODY);
  if (clean.endsWith('X')) {
    body = clean.slice(0, -1);
    dv = 'X';
  }

  let out = body.slice(0, 2);
  if (body.length > 2) out += '.' + body.slice(2, 5);
  if (body.length > 5) out += '.' + body.slice(5, 8);
  if (dv) out += '-' + dv;
  return out;
};

// 11 dígitos → CIN (000.000.000-00); 10 → sem pontuação; até 9 → RG (00.000.000-0).
export const formatRgCin = (value) => {
  const clean = sanitizeRg(value);
  if (/^\d{11}$/.test(clean)) return formatCin(clean);
  if (clean.length === 10) return clean;
  return formatRg(clean);
};
